export const tins = `23404826
23406899
26720917
26729869
26732372
26740156
26740894
28242791
28244136
28255432
28257497
35307244
35316606
48016146
48018666
48018975
48019437
48023063
48024556
48025945
48027442
48028325
49734352
49838307
49840865
54766869
56211318
57376149
57500701
57507908
67144044
67145399
71090391
73045373
73066286
73077411
75477176
75480041
75480627
76876772
76886604
76887141
76887871
76891473
77605024
77993301
77993946
77994741
78717455
88325696
25406606
49831564
23407273`;